import './App.css';
import { useCallback, useEffect } from 'react'
import {
  Row,
  Container,
  Image,
  // @ts-ignore
} from 'atomize';

function PlaygroundExtra() {
  function gRI(max: number) {
    return Math.floor(Math.random() * max) + 1;
  }

  const getPalette = useCallback(() => {
    const rand = gRI(5)
    switch (rand) {
      case 1: {
        return ['%230F2A38', '%231D3C43', '%232A4930', '%23132F13', '%23092409']
      }
      case 2: {
        return ['%23ece0d1', '%23dbc1ac', '%23967259', '%23634832', '%2338220f']
      }
      case 3: {
        return ['%23b3e7dc', '%23a6b401', '%23eff67b', '%23d50102', '%236c0102']
      }
      case 4: {
        return ['%237c7b89', '%23f1e4de', '%23f4d75e', '%23e9723d', '%230b7fab']
      }
      case 5: {
        return ['%23000000', '%233d3d3d', '%23848484', '%23bbbbbb', '%23ffffff']
      }
      default: {
        return ['%23000000', '%233d3d3d', '%23848484', '%23bbbbbb', '%23ffffff']
      }
    }
  }, [])

  //white">
  const svgHead = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="moreorless" width="1000" height="1000" viewBox="0 0 1000 1000" style="background-color:`
  const svgBottom = `</svg>`

  const generateLines = useCallback((num: number) => {
    let lineString = ''
    const palette = getPalette()
    for (let i = 0; i < num; i++) {
      lineString += `<path style='fill:none; stroke:${palette[gRI(5)]}; stroke-width: 10px;'`
      lineString += ` d='M${gRI(400)} ${gRI(400)} `
      lineString += `S${gRI(1000)} ${gRI(1000)} ${gRI(1000)} ${gRI(1000)}`
      lineString += `Z'/>`
    }

    return lineString
  }, [getPalette])

  const generateRectangles = useCallback((num: number) => {
    let rectangleString = ''
    const palette = getPalette()
    for (let i = 0; i < num; i++) {
      rectangleString += `<rect width='${gRI(400)}' height='${gRI(400)}' x='${gRI(1000)}' y='${gRI(1000)}'`
      rectangleString += ` fill='${palette[gRI(5)]}'`
      rectangleString += '/>'
    }

    return rectangleString
  }, [getPalette])

  const generateTriangles = useCallback((num: number) => {
    let triangleString = ''
    const palette = getPalette()
    for (let i = 0; i < num; i++) {
      triangleString += `<polygon points='${gRI(1000)},${gRI(1000)} ${gRI(1000)},${gRI(1000)} ${gRI(1000)},${gRI(1000)}'`
      triangleString += ` fill='${palette[gRI(5)]}'`
      triangleString += '/>'
    }

    return triangleString
  }, [getPalette])

  const generateCircles = useCallback((num: number) => {
    let circleString = ''
    const palette = getPalette()
    for (let i = 0; i < num; i++) {
      circleString += `<ellipse cx='${gRI(1000)}' cy='${gRI(1000)}'`
      circleString += ` rx='${gRI(100)}' ry='${gRI(100)}' fill='${palette[gRI(5)]}'`
      circleString += '/>'
    }

    return circleString
  }, [getPalette])

  const generateArt = useCallback(() => {
    const whichShape = gRI(3)

    let numCircles = gRI(10)
    const numLines = gRI(10)
    let numTriangles = gRI(10)
    let numRects = gRI(10)
    const bgColor = getPalette()[gRI(4)]
    // const decider = "<text x='20' y='990' style='fill:red;' font-size='50'>THE DECIDER</text>"
    
    switch (whichShape) {
      case 0: {
        return `${svgHead}${bgColor}">${generateCircles(numCircles)}${generateLines(numLines)}${svgBottom}`
      }
      case 1: {
        return `${svgHead}${bgColor}">${generateTriangles(numTriangles)}${generateLines(numLines)}${svgBottom}`
      }
      case 2: {
        return `${svgHead}${bgColor}">${generateRectangles(numRects)}${generateLines(numLines)}${svgBottom}`
      }
      default: {
        numCircles = gRI(10)
        numTriangles = gRI(10 - numCircles)
        numRects = gRI(10 - numCircles- numTriangles)

        return `${svgHead}${bgColor}">${generateCircles(numCircles)}${generateTriangles(numTriangles)}${generateRectangles(numRects)}${generateLines(numLines)}${svgBottom}`
      }
    }
  }, [generateCircles, generateLines, generateRectangles, generateTriangles, svgBottom, svgHead, getPalette])

  useEffect(() => {

    const wrapper = async () => {
      generateArt()
    }

    wrapper()
  }, [svgBottom, svgHead, generateArt])

  let rows = []
  for (let i = 0; i < 10; i++) {
    let columns = []
    for (let j = 0; j < 10; j++) {
      columns.push(<Image src={`${generateArt()}`} alt="Play mint" style={{width: '100px', height: '100px'}} />)
    }
    rows.push(columns)
  }

  return (
    <Container className="App" fontFamily="code">
      <Row p={{ l: "5%", t:"3%", b:'5%'}}>
        {rows}
      </Row>
    </Container>
  );
}

export default PlaygroundExtra;
